import { CircularProgress } from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import { FormQuestionNames } from 'tuapath-common/generated/schema';
import { SiteContext, StudentsContext, UserContext } from '../../contexts';
import * as DTO from '../../dto';
import { useFormAndSubmission } from '../../hooks';
import { getFormQuestions } from '../DynamicForm/common';
import BrowseStudentsInner from './BrowseStudentsInner';

export const BrowseStudents: React.FC = () => {
  const siteCtx = useContext(SiteContext);
  const studentsCtx = useContext(StudentsContext);
  const userCtx = useContext(UserContext);
  const { loading, data } = useFormAndSubmission({
    fetchPolicy: 'cache-and-network',
    variables: {
      formId: siteCtx.site?.studentsFilterForm?.id ?? 0,
      userId: userCtx.user?.id ?? 0
    }
  });

  useEffect(() => {
    if (data?.form.elements && studentsCtx && !studentsCtx.filters) {
      const questions = getFormQuestions(data.form);

      const filters: DTO.SubmitFormInput = {
        formId: siteCtx.site?.studentsFilterForm?.id ?? 0,
        saveOnly: false,
        answers: questions.map(q => {
          const input: DTO.FormAnswerInput = { questionId: q.id };

          if (q.name === FormQuestionNames.openCases || q.name === FormQuestionNames.closingCases) {
            input.text = 'true';
          } else if (q.questionType === DTO.FormQuestionType.BOOLEAN) {
            input.text = 'false';
          }

          return input;
        })
      };

      studentsCtx.setFilters(filters);
    }
  }, [data]);

  return loading ? <CircularProgress color="primary" /> : <BrowseStudentsInner />;
};

export default BrowseStudents;
